import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { toast } from 'react-toastify'; // Assuming react-toastify is installed and configured
import { BASE_URL } from '../../api/ApiConfig'; // Assuming BASE_URL is imported similarly to ROOT_URL

export const deleteKbCategory = createAsyncThunk(
  'kbCategory/deleteKbCategory',
  async ({ categoryId, group_id }, { getState, rejectWithValue }) => {
    try {
      const { loginToken } = getState();
      const authToken = loginToken?.response?.token;

      const response = await axios.delete(
        `${BASE_URL}/trustchat-backend-service/v1/kb/category/${categoryId}`,
        {
          headers: {
            'Authorization': `Bearer ${authToken}`,
            'Content-Type': 'application/json'
          },
          params: group_id ? { group_id } : undefined,
          data: group_id ? { group_id } : undefined,
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  success: false,
  data: null,
};

const deleteKbCategorySlice = createSlice({
  name: 'deleteKbCategory',
  initialState,
  reducers: {
    resetDeleteKbCategoryState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.data = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteKbCategory.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(deleteKbCategory.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.data = action.payload;
        toast.success(action.payload.message || 'Category deleted successfully.');
      })
      .addCase(deleteKbCategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
        toast.error(action.payload?.message || 'Failed to delete category.');
      });
  }
});

export const { resetDeleteKbCategoryState } = deleteKbCategorySlice.actions;
export default deleteKbCategorySlice.reducer;